// extracted by mini-css-extract-plugin
export default {"empty":"Empty-empty___jyEre"};